import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'selectedProfileRowTemplate', 'selectedProfilePicture', 'selectedProfileDisplayName', 'selectedProfileRoles', 'selectedProfileFirstName', 'selectedProfileLastName',
    'selectButton', 'removeButton'
  ]

  selectUser (event) {
    this.dispatch('user-selected', {
      detail: {
        profileId: event.currentTarget.dataset.profileId,
        profilePicture: this.selectedProfilePictureTarget.src,
        displayName: this.selectedProfileDisplayNameTarget.textContent,
        roles: Array.from(this.selectedProfileRolesTarget.querySelectorAll('span')).map(span => span.textContent),
        firstName: this.selectedProfileFirstNameTarget.textContent,
        lastName: this.selectedProfileLastNameTarget.textContent
      }
    })
  }

  removeUser (event) {
    this.dispatch('user-removed', {
      detail: {
        profileId: event.currentTarget.dataset.profileId
      }
    })
  }
}
